import { Routes } from '@angular/router';

export const routes: Routes = [
  
      {
        path: '',
        loadChildren: () => import('./modules/automation-plan/automation-plan.routes').then((r) => r.AUTOMATION_PLAN_ROUTES)
      }
];
